import {KpiOrderBy} from '@store/@types/kpi';
import React from 'react';
import TableSortLabel from '@material-ui/core/TableSortLabel';

interface KpiHeaderProps {
  className: string;
  // Name of this specific header
  name: KpiOrderBy;
  children: React.ElementType | string;
  direction: 'asc' | 'desc';
  // Column which is being sorted
  orderBy: KpiOrderBy | undefined;
  setOrder: (order: KpiOrderBy) => void;
}

export const KpiHeader: React.FC<KpiHeaderProps> = ({
  className,
  name,
  children,
  orderBy,
  direction,
  setOrder,
}) => {
  return (
    <th className={className}>
      <TableSortLabel
        active={orderBy === name}
        direction={orderBy === name ? direction : 'asc'}
        onClick={() => setOrder(name)}
        id={name}>
        {children}
      </TableSortLabel>
    </th>
  );
};
